const map = require('lodash/fp/map');
const memoizer = require('../request-handler/utils/memoizer');

function parseResult(res) {
  if(!res){
    return null;
  }
  return JSON.stringify(res);
}

function serviceFactory({ api }) {
  const initializeTx = memoizer()((txType, metaData) =>
    api.initializeTx(txType, metaData)
    .then(parseResult)
    .catch((error) => {
      return null;
    })
  );

  const generateTxChallenge = memoizer()((fieldObj,txType, metaData) =>
    api.generateTxChallenge(fieldObj,txType, metaData)
    .then(parseResult)
    .catch((error) => {
      return null;
    })
  );

  const verifyChallengeResponse = memoizer()((details, metaData) =>
    api.verifyChallengeResponse(details, metaData).then((response) => {
      if (!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
      return null;
    })
  );

  return {
    initializeTx,
    generateTxChallenge,
    verifyChallengeResponse
  };

}

module.exports = serviceFactory;